import SchemaScreen from './index';

const routes = [
  {
    path: '/master/schema',
    component: SchemaScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.platform.schema.kurir'],
  },
];

export default routes;
